<!-- Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. -->

<div
	class="light-panel passive-plan-prompt dependency-prompt"
	*ngIf="(mode | async)?.target"
	[hidden]="_hidden$ | async"
>
	<div class="passive-plan-prompt-description">{{ strings.DEPENDENCY_PROMPT_DESCRIPTION }}</div>
	<!-- <div class="passive-plan-prompt-button" (click)="toggleSelectAll()">
		<i *ngIf="(mode | async).isAllType"><% require('@touchplan/strings').DEPENDENCY_PROMPT_TOGGLE_TO_SELECTED %></i>
		<i *ngIf="!(mode | async).isAllType"><% require('@touchplan/strings').DEPENDENCY_PROMPT_TOGGLE_TO_ALL %></i>
	</div>
	<div class="passive-plan-prompt-button" (click)="exit()">
		<i>Exit</i>
	</div> -->
</div>
